const nrkMixin = {
    data() {
        return {
            RESOURCE_NRK_ID: 3,
        }
    },
    methods: {
        fetchNrkOptions() {
            let params = {
                typeId: this.RESOURCE_NRK_ID
            };
            return this.axios.get( this.$config.urls.nrk.nrkOptions.url, { params: params } )
                       .then( response => {
                           return response.data.data;
                       } ).catch(()=>{});
        },
        fetchNrkResources() {
            let params = {
                typeId: this.RESOURCE_NRK_ID
            };
            return this.axios.get( this.$config.urls.structure.fetchStructureResourceOptions.url, { params: params } )
                       .then( response => {
                           this.items = response.data.data.map( item => {
                               item.title = item.title + ' (' + item.resourceTitle + ')';
                               return item;
                           } );
                       } ).catch(()=>{});
        },
        
    }
};

export default nrkMixin;
